import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
} from '@mui/material';
import * as subMatFolderActions from '../../store/subMatFolder';

const SubMatFolderCreateDialog = ({
  open,
  onClose,
  parentFolder,
  onCreated,
}) => {
  const dispatch = useDispatch();
  const [name, setName] = useState('');
  const [errors, setErrors] = useState([]);

  const rootKind = parentFolder?.rootKind;

  useEffect(() => {
    if (open) {
      setName('');
      setErrors([]);
    }
  }, [open]);

  const handleSubmit = async () => {
    setErrors([]);
    const trimmed = name.trim();
    if (!trimmed) {
      setErrors(['폴더 이름을 입력하세요.']);
      return;
    }
    try {
      const created = await dispatch(subMatFolderActions.create({
        id: uuidv4(),
        parentId: parentFolder.id,
        rootKind,
        name: trimmed,
      }));
      onCreated?.(created);
      onClose();
    } catch (res) {
      const data = typeof res?.json === 'function' ? await res.json() : res?.serverResponse;
      if (data?.errors) setErrors(data.errors);
      else if (data?.message) setErrors([data.message]);
      else setErrors(['폴더 생성에 실패했습니다.']);
    }
  };

  if (!parentFolder) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        폴더 추가 — {subMatFolderActions.ROOT_KIND_LABEL[rootKind] || rootKind}
      </DialogTitle>
      <DialogContent>
        <ul>{errors.map((e, i) => <li key={i} style={{ color: 'red' }}>{e}</li>)}</ul>
        <Grid container spacing={2} sx={{ mt: 0.5 }}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              size="small"
              label="폴더 이름"
              value={name}
              onChange={(e) => setName(e.target.value)}
              autoFocus
              onKeyDown={(e) => {
                if (e.key === 'Enter') handleSubmit();
              }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSubmit} variant="contained">저장</Button>
        <Button onClick={onClose}>취소</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SubMatFolderCreateDialog;
